<template>
    <div>
        <div v-if="$store.state.token" class="submit-form" @click="submit"></div>
    </div>
</template>

<script>
import { updateById } from '../api/index';
export default {
    name: '',
    data() {
        return {};
    },
    props: {
        form: {},
        refComponentId: {},
        id: {}
    },
    methods: {
        submit() {
            let data = {
                context: JSON.stringify(this.form),
                refComponentId: this.refComponentId,
                id: this.id,
                type: 'PSwiper'
            };
            updateById(data).then(res => {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                location.reload();
            });
        }
    }
};
</script>

<style scoped>
.submit-form {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 50;
    cursor: pointer;
    background: url('../assets/submit.png');
    background-size: 100% 100%;
}
</style>
